import axios from "axios";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

const MenuBoardHome = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    checkValidId();
  }, []);

  const checkValidId = async () => {
    const search = new URLSearchParams(location.search);
    const tableNo = search.get("tableNo");
    const cmpnyNo = search.get("cmpnyNo");

    // const [cmpnyNo, tableNo] = await Promise.all([
    //   getEncryptId(search.get("cmpnyNo")),
    //   getEncryptId(search.get("tableNo")),
    // ]);

    if (tableNo) {
      try {
        localStorage.setItem(`mbTableNo:${cmpnyNo}`, tableNo);
      } catch (e) {
        console.error("로컬 저장 실패", e);
      }
    }

    if (cmpnyNo) {
      const timestamp = Date.now();
      try {
        localStorage.setItem(`timestamp:${cmpnyNo}`, String(timestamp));
      } catch (e) {
        console.error("타임스탬프 저장 실패", e);
      }
      console.log("[MenuBoardHome] redirect before navigate", {
        cmpnyNo,
        tableNo,
        timestamp,
      });
      navigate(`/menu-board/${cmpnyNo}`);
    }
  };

  const getEncryptId = async (id) => {
    const url = "/etc/encrypt-6char";
    const body = { id: parseInt(id, 10) };
    const res = await axios.post(url, body);
    return res.data.code;
  };

  return <div />;
};

export default MenuBoardHome;
